import { useEffect, useState } from 'react';
import { format } from 'date-fns';

import toast from 'react-hot-toast';
import smartToast from '../util/smart_toast';

import downloadIcon from '../imagens/downloadIcon.png'
import TituloSessao from '../componentes/TituloSessao';
import Paginador from '../componentes/Paginador';
import DataMes from '../componentes/DataMes';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';

import { servDownloadFormularioAcompanhamento } from '../servicos/servicosEmRotasPrivadas/download';
import { servGetFormulariosPorMes } from '../servicos/servicosEmRotasPrivadas/formulario_acompanhamento';

function DownloadRelatorioAcompanhamento() {

    console.log(' #### Iniciando Download Formulário Acompanhamento ####');

    const [arquivosFormularioDownload, setArquivosFormularioDownload] = useState(null)
    const [mesReferencia, setMesReferencia] = useState('')
    const [page, setPage] = useState(0)
    const [estabelecimento, setEstabelecimento] = useState(null)

    console.log(arquivosFormularioDownload);

    useEffect(() => {
        if (mesReferencia) {
            setPage(0)
            // Esse UseEffect so deve ser executado quando da um reset na busca
            // se nao for uma 'busca reset', deixa que o UseEffect do page faz a busca
            if (page === 0) getFormulariosPorMes() // se o page ja for 0, ai eu busco. Nem sempre essa var muda
        }
    }, [mesReferencia, estabelecimento]);

    useEffect(() => {
        if (mesReferencia) getFormulariosPorMes()
    }, [page]);

    async function getFormulariosPorMes() {

        try {

            const formulariosDaApi = await smartToast(
                servGetFormulariosPorMes(mesReferencia, page, estabelecimento),
                {
                    loadingMessage: 'Buscando formulários...',
                    apenasLoading: true
                },
            );

            if (formulariosDaApi.data.formularios.length <= 0) {
                setArquivosFormularioDownload(null)
                toast('Não há formulários para o mês selecionado')
            } else {
                setArquivosFormularioDownload(formulariosDaApi.data)
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message)
        }

    }

    async function downloadFormularioAcompanhamento(formularioAcompanhamentoId) {
        try {
            await servDownloadFormularioAcompanhamento(formularioAcompanhamentoId)
        } catch (error) {
            if (error.status === 403) {
                toast.error(error.message)
            }
            console.error(error);
        }
    }

    return (
        <div className='container d-flex flex-column align-items-center gap-2'>
            <TituloSessao titulo='Download Relatório de Acompanhamento' barraDecorativa={false} />
            <div className='div-com-borda w-100 d-flex gap-3 p-3 align-items-center'>
                <div className='d-flex gap-3 align-items-center'>
                    <label className='text-nowrap' htmlFor='mes-competencia'>Mês de Competência</label>
                    <DataMes
                        mes={mesReferencia}
                        setData={setMesReferencia}
                        getUltimoDia={false}
                        id='mes-competencia'
                    />
                </div>
                <div className='col-md-8'>
                    <BarraBuscaComTodasUnidades
                        id='barra-busca'
                        setEstabelecimento={setEstabelecimento}
                        somenteAtivos={false}
                        enviaRelatorioAcompanhamento={false}
                    />
                </div>
            </div>
            {arquivosFormularioDownload && mesReferencia ?
                arquivosFormularioDownload.formularios.length > 0 ?
                    <div className='w-100 d-flex flex-column'>
                        <div className='text-center div-com-borda p-1'>
                            <p className='text-dark m-0'>As unidades que constam abaixo <strong>enviaram</strong> o Formulários de Acompanhamento no mês selecionado</p>
                        </div>
                        <table className='table text-center table-striped'>
                            <thead>
                                <tr>
                                    <th scope="col" className='p-1'>Id do Formulário</th>
                                    <th scope="col" className='p-1'>Estabelecimento</th>
                                    <th scope="col" className='p-1'>Data Criação</th>
                                    <th scope="col" className='p-1'>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arquivosFormularioDownload.formularios.map((formulario) => (
                                    <tr key={formulario.formulario_id}>
                                        <td className='p-1'>{(formulario.formulario_id)}</td>
                                        <td className='p-1'>{(formulario.estabelecimento)}</td>
                                        <td className='p-1'>{format(new Date(formulario.data_criacao), 'dd/MM/yyyy HH:mm:ss')}</td>
                                        <td className='p-1'>
                                            <img className='downloadIcon'
                                                alt='icone de download'
                                                src={downloadIcon}
                                                onClick={() => downloadFormularioAcompanhamento(formulario.formulario_id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <Paginador page={page} setPage={setPage} itemsPerPage={arquivosFormularioDownload.tamanho_pagina} totalItems={arquivosFormularioDownload.total} />
                    </div>
                    :
                    <div>Não há resultados para os filtros selecionados</div>
                :
                <div>Selecione um mês para listar os Formulários enviados</div>
            }
        </div>
    );
}

export default DownloadRelatorioAcompanhamento
